import React, { useState } from "react";
import { CSSTransition } from "react-transition-group";

function Carousel({ items }) {
  const [current, setCurrent] = useState(0);
  const [isNext, setIsNext] = useState(true);

  const handlerPrev = () => {
    let index = current;
    let length = items.length;

    if (index < 1) {
      index = length;
    }

    index = index - 1;

    setCurrent(index);
    setIsNext(false);
  };

  const handlerNext = () => {
    let index = current;
    let length = items.length - 1;

    if (index === length) {
      index = -1;
    }

    index = index + 1;

    setCurrent(index);
    setIsNext(true);
  };

  let index = current;
  let isnext = isNext;
  let src = items[index];

  return (
    <div className="carousel">
      <CSSTransition
        timeout={200}
        transitionname={{
          enter: isnext ? "enter-next" : "enter-prev",
          enterActive: "enter-active",
          leave: "leave",
          leaveActive: isnext ? "leave-active-next" : "leave-active-prev",
        }}
      >
        <div className="carousel_slide" key={index}>
          <img
            src={`${process.env.REACT_APP_BTC_API_URL}/${src}`}
            alt={`Slide ${index + 1}`}
          />
        </div>
      </CSSTransition>
      <button
        className="carousel_control carousel_control__prev"
        onClick={handlerPrev}
      >
        <span></span>
      </button>
      <button
        className="carousel_control carousel_control__next"
        onClick={handlerNext}
      >
        <span></span>
      </button>
    </div>
  );
}

export default Carousel;
